<div
  id="participant-form"
  fsxFocusFirstInput
  *ngIf="contactProfile || combinedFilingData?.filingProfile"
>
  <fsx-contact-type-selection
    *ngIf="config.formMode === participantFormMode.AddParticipant"
    [config]="{ disabled: participantFormGroup.disabled }"
    (contactTypeChangedEvent)="setActiveForm($event)"
  >
  </fsx-contact-type-selection>

  <form [formGroup]="participantFormGroup" class="form-container">
    <ng-container *ngIf="contactType === ContactType.Person">
      <div class="component-container name">
        <fsx-person-name-component
          #personNameField
          *ngIf="personNameFieldDefinition"
          [personNameComponentSpec]="personNameFieldDefinition"
          [resolver]="resolver"
          [initialValues]="personNameInitialValues"
          (formGroupEmitter)="setPersonNameFormGroup($event)"
        ></fsx-person-name-component>
      </div>
    </ng-container>

    <ng-container *ngIf="contactType === ContactType.Organization">
      <div class="component-container org">
        <fsx-text-component
          #organizationField
          *ngIf="organizationFieldDefinition"
          [caption]="'Title'"
          [width]="'100%'"
          [resolver]="resolver"
          [fieldDefinition]="organizationFieldDefinition.title"
          [initialValue]="
            organizationInitialValues ? organizationInitialValues.title : ''
          "
          (formControlEmitter)="setOrganizationFormControl($event)"
        ></fsx-text-component>
      </div>
    </ng-container>

    <div *ngIf="showBarIdentificationComponent">
      <div class="component-container">
        <fsx-label-with-validation
          [labelText]="'Bar Number'"
          [abstractControl]="participantFormGroup.controls.barIdentifications!"
        >
        </fsx-label-with-validation>
        <fsx-identification-component
          #barNumberField
          [resolver]="resolver"
          [showBarId]="showBarIdentificationComponent"
          [editMode]="config.formMode !== participantFormMode.AddParticipant"
          [identificationSpec]="identificationSpec"
          [initialValues]="barIdentificationInitialValues"
          [idLength]="idLength"
          (formArrayEmitter)="setBarFormArray($event)"
        ></fsx-identification-component>
      </div>
    </div>

    <div class="component-container">
      <fsx-label-with-validation
        [labelText]="'Address'"
        [abstractControl]="participantFormGroup.controls.addresses!"
      >
      </fsx-label-with-validation>
      <fsx-address-component
        #addressField
        [resolver]="resolver"
        [editMode]="config.formMode !== participantFormMode.AddParticipant"
        [fieldDefinition]="addressFieldDefinition"
        [initialValues]="addressInitialValues"
        (formArrayEmitter)="setAddressFromArray($event)"
      ></fsx-address-component>
    </div>

    <div class="component-container">
      <fsx-label-with-validation
        [labelText]="'Phone'"
        [abstractControl]="participantFormGroup.controls.phones!"
      >
      </fsx-label-with-validation>
      <fsx-phone-component
        #phoneField
        [resolver]="resolver"
        [editMode]="config.formMode !== participantFormMode.AddParticipant"
        [phoneComponentSpec]="phoneFieldDefinition"
        [initialValues]="phoneInitialValues"
        (formArrayEmitter)="setPhoneFormArray($event)"
      ></fsx-phone-component>
    </div>

    <div class="component-container">
      <fsx-label-with-validation
        [labelText]="'Email'"
        [abstractControl]="participantFormGroup.controls.emails!"
      >
      </fsx-label-with-validation>
      <fsx-email-component
        #emailField
        [resolver]="resolver"
        [editMode]="config.formMode !== participantFormMode.AddParticipant"
        [emailComponentSpec]="emailFieldDefinition"
        [initialValues]="emailInitialValues"
        (formArrayEmitter)="setEmailFormArray($event)"
      ></fsx-email-component>
    </div>

    <ng-container *ngIf="showOtherIdentificationComponent">
      <div class="component-container">
        <fsx-label-with-validation
          [labelText]="'Email'"
          [abstractControl]="
            participantFormGroup.controls.otherIdentifications!
          "
        >
        </fsx-label-with-validation>
        <fsx-identification-component
          #identificationField
          [resolver]="resolver"
          [showOtherId]="showOtherIdentificationComponent"
          [editMode]="config.formMode !== participantFormMode.AddParticipant"
          [identificationSpec]="identificationSpec"
          [initialValues]="otherIdentificationInitialValues"
          [idLength]="idLength"
          (formArrayEmitter)="setOtherIdFormArray($event)"
        ></fsx-identification-component>
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        (contactProfile || combinedFilingData.filingProfile) &&
        aliasFieldDefinition
      "
    >
      <div class="component-container">
        <fsx-label-with-validation
          [labelText]="'Aliases'"
          [abstractControl]="participantFormGroup.controls.aliases!"
        >
        </fsx-label-with-validation>
        <fsx-alias-component
          #aliasField
          [contactType]="contactType"
          (formArrayEmitter)="setAliasFromArray($event)"
          [profile]="contactProfile || combinedFilingData.filingProfile"
          [participantSpec]="participantSpec"
          [editMode]="config.formMode !== participantFormMode.AddParticipant"
          [resolver]="resolver"
          [aliasFieldDefinition]="aliasFieldDefinition"
          [initialValues]="aliasInitialValues"
        ></fsx-alias-component>
      </div>
    </ng-container>
  </form>
</div>
